const columnsThemes = [
  { name: 'name', align: 'left', label: 'Nome', field: 'name', sortable: true },
  { name: 'description', align: 'left', label: 'Descrição', field: 'description', sortable: true },
  { name: 'actions', label: 'Ações', field: 'actions', sortable: false }
]

export {
  columnsThemes
}
